import React, { useRef, useState } from 'react';
import { toPng } from 'html-to-image';
import { Download, Share2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { QR_APP_DATA, QR_MAP_DATA } from '../../utils/qrData';

const RED = '#B5452A';
const DARK = '#2D2016';
const HEAVY = "'Arial Black', 'Arial', sans-serif";
const FILE_NAME = 'central-hotel-story-4cesit-10euro.png';

const StoryCanvas = React.forwardRef(({ assets }, ref) => (
  <div ref={ref} data-testid="story-canvas" style={{ width: '360px', height: '640px', background: '#F5EDE4', fontFamily: "'Georgia', 'Times New Roman', serif", position: 'relative', overflow: 'hidden', borderRadius: '6px', boxShadow: '0 8px 32px rgba(0,0,0,0.15)', display: 'flex', flexDirection: 'column' }}>
    <div style={{ position: 'relative', height: '230px', flexShrink: 0 }}>
      <img src={assets.hero4 || assets.food || ''} alt="" style={{ width: '100%', height: '230px', objectFit: 'cover', display: 'block' }} />
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(30,20,12,0.65) 0%, rgba(30,20,12,0) 30%, rgba(30,20,12,0) 75%, rgba(245,237,228,1) 100%)' }} />
      <div style={{ position: 'absolute', top: '22px', left: 0, right: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
        <img src={assets.logo || ''} alt="" style={{ height: '34px', borderRadius: '4px' }} />
        <div>
          <p style={{ color: '#FFF', fontSize: '13px', fontWeight: '800', letterSpacing: '2px' }}>CENTRAL HOTEL</p>
          <p style={{ color: '#F2C9A0', fontSize: '7.5px', letterSpacing: '2.5px', fontWeight: '700' }}>RESTAURANT & KITCHEN</p>
        </div>
      </div>
      <div style={{ position: 'absolute', right: '16px', bottom: '4px', width: '124px', height: '124px', borderRadius: '50%', background: RED, border: '4px solid #F5EDE4', boxShadow: '0 6px 18px rgba(0,0,0,0.35)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#FFF', transform: 'rotate(-8deg)' }}>
        <span style={{ fontSize: '12px', fontWeight: '800', letterSpacing: '2px' }}>4 ÇEŞİT</span>
        <span style={{ fontSize: '46px', fontWeight: '900', lineHeight: '1', fontFamily: HEAVY }}>€10</span>
        <span style={{ fontSize: '9px', fontWeight: '700', letterSpacing: '1.5px', marginTop: '2px' }}>SADECE / ONLY</span>
      </div>
    </div>
    <div style={{ padding: '6px 22px 0' }}>
      <p style={{ fontSize: '31px', fontWeight: '900', color: DARK, lineHeight: '1.02', fontFamily: HEAVY }}>4 ÇEŞİT YEMEK<br /><span style={{ color: RED }}>SADECE €10!</span></p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', margin: '10px 0 8px' }}>
        {['Çorba', 'Ana Yemek', 'Yardımcı', 'Salata'].map((t, i) => (
          <div key={t} style={{ background: DARK, color: '#F5EDE4', borderRadius: '8px', padding: '7px 10px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '18px', fontWeight: '900', color: '#F2A36B', fontFamily: HEAVY }}>{i + 1}</span>
            <span style={{ fontSize: '12px', fontWeight: '800' }}>{t}</span>
          </div>
        ))}
      </div>
      <div style={{ fontSize: '9.5px', color: '#4A3A2C', lineHeight: '1.5', borderLeft: `3px solid ${RED}`, paddingLeft: '8px' }}>
        <p><b>EN</b> 4 dishes, only €10: Soup + Main + Side + Salad</p>
        <p><b>ME</b> 4 jela, samo €10: Supa + Glavno jelo + Prilog + Salata</p>
        <p><b>RU</b> 4 блюда, всего €10: Суп + Основное + Гарнир + Салат</p>
      </div>
    </div>
    <div style={{ flex: 1 }} />
    <div style={{ margin: '0 22px 10px', display: 'flex', gap: '10px' }}>
      {[{ src: QR_APP_DATA, t: 'SİPARİŞ VER', s: 'Order · Naruči · Заказать' }, { src: QR_MAP_DATA, t: 'KONUM', s: 'Location · Lokacija · Адрес' }].map(q => (
        <div key={q.t} style={{ flex: 1, background: '#FFF8F0', border: `2px solid ${RED}`, borderRadius: '10px', padding: '7px', textAlign: 'center' }}>
          <img src={q.src} alt={q.t} style={{ width: '84px', height: '84px', display: 'block', margin: '0 auto' }} />
          <p style={{ fontSize: '12px', fontWeight: '900', color: RED, marginTop: '4px' }}>{q.t}</p>
          <p style={{ fontSize: '7.5px', color: '#5C4A3A' }}>{q.s}</p>
        </div>
      ))}
    </div>
    <div style={{ height: '34px', flexShrink: 0, background: RED, color: '#FFF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', fontWeight: '800', letterSpacing: '0.5px' }}>
      13 Jula 6, Budva · +382 69 144 043 · centralhotel.org
    </div>
  </div>
));

export const BrochureStory = ({ assets }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(null);

  const capture = () => toPng(ref.current, { pixelRatio: 3, backgroundColor: '#F5EDE4', cacheBust: true, skipAutoScale: true });

  const download = (dataUrl) => {
    const a = document.createElement('a');
    a.download = FILE_NAME; a.href = dataUrl; a.click();
  };

  const run = async (mode) => {
    setBusy(mode);
    try {
      const dataUrl = await capture();
      if (mode === 'share') {
        const blob = await (await fetch(dataUrl)).blob();
        const file = new File([blob], FILE_NAME, { type: 'image/png' });
        if (navigator.canShare?.({ files: [file] })) {
          await navigator.share({ files: [file], title: 'Central Hotel', text: '4 çeşit yemek sadece €10! centralhotel.org' });
          return;
        }
        toast.info('Bu cihaz doğrudan paylaşımı desteklemiyor, PNG indirildi.');
      }
      download(dataUrl);
      if (mode === 'png') toast.success('Story PNG indirildi (1080×1920)');
    } catch (err) {
      if (err?.name !== 'AbortError') toast.error('Story oluşturulamadı: ' + (err.message || ''));
    } finally { setBusy(null); }
  };

  return (
    <div className="space-y-4 border-t pt-8" data-testid="story-section">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="font-playfair text-xl font-semibold text-charcoal">Story (1080×1920)</h2>
          <p className="text-sm text-charcoal/60">Instagram ve WhatsApp durum paylaşımı için</p>
        </div>
        <div className="flex gap-2">
          <Button onClick={() => run('png')} disabled={!!busy} variant="outline" className="rounded-full" data-testid="story-download-png">
            {busy === 'png' ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Download className="w-4 h-4 mr-1" />}Story PNG
          </Button>
          <Button onClick={() => run('share')} disabled={!!busy} className="bg-gradient-to-r from-pink-600 to-orange-500 text-white rounded-full" data-testid="story-share-btn">
            {busy === 'share' ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Share2 className="w-4 h-4 mr-1" />}Paylaş
          </Button>
        </div>
      </div>
      <div className="flex justify-center"><StoryCanvas ref={ref} assets={assets} /></div>
    </div>
  );
};

export default BrochureStory;
